<template>
    <MonitorLayoutTemplate
        :table_title="table_title"
    >
        <template #datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>

        <template #description>
            <SignsCalculator 
                :data="sign_data"
                :setting="sign_setting"
            />
        </template>

        <template #signs>
            <MonitorSigns
                :data="sign_data"
            />
        </template>

        <template #data_table="slot_props">
            <QpeDatatable
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :props_date="date"
                :props_time="time"
                :search="slot_props.search"
                :should_display_info_header_key_value="should_display_info_header_key_value"
                :generate_tooltop_display_info="generate_tooltop_display_info_for_table"
                :should_show_raw_html_header="should_show_raw_html_header"
                :show_footer="true"
                :show_download_pdf_btn="show_download_pdf_btn"
                :props_items_per_page="100"
                no_data_text="目前無警示測站"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            >
                <template #table_description>
                    <span>{{ custom_alert_text[2] ? custom_alert_text[2] : '二級' }}警戒： <v-icon class="signal--warning">icon-pentagon</v-icon></span>
                    <span>{{ custom_alert_text[1] ? custom_alert_text[1] : '一級' }}警戒： <v-icon class="signal--action">icon-triangle</v-icon></span>
                </template>
            </QpeDatatable>
        </template>        
    </MonitorLayoutTemplate>
</template>

<script>
    import {redirect_monitor_table_ajax} from "@/utils/monitor/monitor.js"
    import { judge_invalid_data_by_keys, sort_table_data, reconstruct_alert_content } from "@/utils/monitor/common_tool.js"
    import { monitor_mixin } from "@/utils/monitor/monitor_mixin.js"
    import cloneDeep from 'lodash/cloneDeep'
    import { 
        monitor_signs_normal_mapping, 
        monitor_signs_normal_mapping_css, 
        TABLE_VALUE_TEXT_MAPPING
    } from "@/config/monitor_config.js"
    import MonitorLayoutTemplate from "@/components/monitor/_tool/layout_template.vue"
    import QpeDatetime from "@/components/monitor/qpe_datetime.vue"
    import SignsCalculator from "@/components/monitor/_tool/signs_calculator.vue";
    import MonitorSigns from "@/components/monitor/_tool/monitor_signs.vue"
    import QpeDatatable from "@/components/monitor/qpe_datatable.vue"

    export default {
        name: 'LandslideStream',

        components: { 
            MonitorLayoutTemplate,
            QpeDatetime,
            SignsCalculator,
            QpeDatatable, 
            MonitorSigns 
        },

        mixins: [monitor_mixin],

        props: {
            in_overview_page: {
                type: Boolean,
                default() {
                    return false
                }
            },
            default_value: {
                type: Number,
                required: true,
            },
            custom_alert_text: {
                type: Object,
                default() {
                    return { 1: '', 2: '' }
                }
            },
        },

        
        data() {
            return {
                header: [],
                table_data: [],
                error_text: '',
                
                immutable_table_data: [],

                should_display_info_header_key_value: {
                    '警示理由': {},
                },

                should_show_raw_html_header: ['警示'],
            }
        },
        
        computed: {
            table_title() {
                return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}資訊`
            },

            sign_data() {
                return this.immutable_table_data.map(item => {
                    const each_sign_data = {
                        idx: item['項次'],
                        signs_num: monitor_signs_normal_mapping[item['警示']] || '-'
                    }
                    return each_sign_data
                });
            },

            sign_setting() {
                return [
                    { text: '黃燈', icon: ['signal--warning', 'icon-pentagon'], value: '3'},
                    { text: '紅燈', icon: ['signal--action', 'icon-triangle'], value: '1'},
                ]
            },

            enable_filter_unalert_data() {
                return this.in_overview_page
            },

            show_download_pdf_btn() {
                return !this.in_overview_page
            },
        },
        
        created() {
            redirect_monitor_table_ajax.call(this, this.default_value)
        },

        methods: {
            generate_table_data (data, header) {
                this.immutable_table_data = data;
                
                let table_data
                if(this.enable_filter_unalert_data) {
                    table_data = data.filter(datum => judge_invalid_data_by_keys(datum, ['警示']));
                } else {
                    table_data = data;
                }
                const sorted_data = sort_table_data(table_data, monitor_signs_normal_mapping)
                this.table_data = reconstruct_alert_content(sorted_data, this.should_show_raw_html_header);
                
                this.header = header;
            },

            generate_tooltop_display_info_for_table(row) {
                return row['警示條件']
            },
        },
    }
</script>

<style>
</style>